import { useState, useEffect } from 'react'
import { supabase } from '@/integrations/supabase/client'
import { useAuth } from '@/hooks/useAuth'

interface EventTotals {
  login_success_count: number
  login_failed_count: number
  account_locked_count: number
  service_crash_count: number
  application_crash_count: number
  powershell_execution_count: number
}

export function useEventAggregation(hostname: string, timeRange: string) {
  const { session } = useAuth()
  const [eventTotals, setEventTotals] = useState<EventTotals>({
    login_success_count: 0,
    login_failed_count: 0,
    account_locked_count: 0,
    service_crash_count: 0,
    application_crash_count: 0,
    powershell_execution_count: 0,
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!session?.access_token || !hostname || !timeRange) {
      return
    }

    const fetchEventAggregation = async () => {
      setLoading(true)
      setError(null)

      try {
        console.log(`Fetching event aggregation for ${hostname} with range ${timeRange}`)
        
        const { data, error } = await supabase.functions.invoke('event-aggregation', {
          body: {
            hostname,
            timeRange
          },
          headers: {
            Authorization: `Bearer ${session.access_token}`,
          },
        })

        if (error) {
          console.error('Error calling event-aggregation function:', error)
          setError('Failed to fetch event aggregation')
          return
        }

        if (data) {
          console.log('Received event totals:', data)
          setEventTotals(data)
        }
      } catch (err) {
        console.error('Error in useEventAggregation:', err)
        setError('Failed to fetch event aggregation')
      } finally {
        setLoading(false)
      }
    }

    fetchEventAggregation()
  }, [session?.access_token, hostname, timeRange])

  return { eventTotals, loading, error }
}